import React, { useState, useEffect } from 'react';
import './Schedule.scss';
import '.././../../helpers/DateHelper';
import DateHelper from '.././../../helpers/DateHelper';

interface ScheduleProps {
  schedules: {
    employeeId: string;
    scheduleId: string;
    stringSchedule_StartTime: string;
    stringSchedule_EndTime: string;
    stringSchedule_Hours: string;
  }[];
  onScheduleSelect: (schedule: {
    employeeId: string;
    scheduleId: string;
    stringSchedule_StartTime: string;
    stringSchedule_EndTime: string;
    stringSchedule_Hours: string;
  }) => void;
  selectedScheduleId:string;
}



const Schedule: React.FC<ScheduleProps> = ({ schedules, onScheduleSelect,selectedScheduleId  }) => {
  const [selectedOption, setSelectedOption] = useState<string>('');
   // Set the first schedule as the default selection when component mounts
   useEffect(() => {
    if (schedules.length > 0) {
      const firstSchedule = schedules[0];
      setSelectedOption(firstSchedule.scheduleId);
      onScheduleSelect(firstSchedule); // Notify parent about the default selection
    }
  }, [schedules]);
  

  const handleSelection = (scheduleId: string) => {
    setSelectedOption(scheduleId);
   // Find the selected schedule object
   const selectedSchedule = schedules.find(schedule => schedule.scheduleId === scheduleId);

   // If a schedule is found, pass it to the parent via onScheduleSelect
   if (selectedSchedule) {
    onScheduleSelect(selectedSchedule);
   }
    
  };

  return (
    <div className="dropdown-container">
      <ul className="dropdown-schedule">
        {schedules.map((schedule, index) => {
          const extractedTime = DateHelper.extractScheduleTime(schedule.stringSchedule_EndTime);

          return (
            <li
              key={index}
              className={`dropdown-item-schedule ${schedule.scheduleId === selectedScheduleId ? 'selected' : ''}`}
              onClick={() => handleSelection(schedule.scheduleId)}
            >
              <span className='scheduleDate'>{DateHelper.scheduleDateFormat(new Date(schedule.stringSchedule_StartTime))}</span>
              {/* <img src={arrowImage} className="scheduleArrow" alt="arrow" />  */}
              -
              <span className='scheduleTime'> {extractedTime.hours}:{extractedTime.minutes} ({schedule.stringSchedule_Hours} Hours)</span>

              {schedule.scheduleId === selectedScheduleId && (
                // <img src={tickImage} className="tick-mark" alt="tick" />
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="tick-mark bi bi-check-circle-fill" viewBox="0 0 17 16">
  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
</svg>
              )}
            </li>
          );
        })}
      </ul>
      {/* <p className='selectedSchedule'><strong>Selected Schedule:</strong> {selectedOption || 'None'}</p> */}
    </div>
  );
};

export default Schedule;
